import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignCenterOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignCenterOutlined";
import AntdIcon from '../components/AntdIcon';
var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: AlignCenterOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(AlignCenterOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'AlignCenterOutlined';
}
export default RefIcon;